"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUICK_BUY = exports.FAVORITE = void 0;
const FAVORITE = exports.FAVORITE = 'favorites';
const QUICK_BUY = exports.QUICK_BUY = 'quick-buy';
